module.exports = __webpack_public_path__ + "img/bio_a.6dc525fc.png";